export { fetchEventSource, EventStreamContentType } from './fetch';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/fetch-event-source/lib/esm/index.js
// module id = 158
// module chunks = 1